const zh_CN = {
  handle: {
    search: '搜索',
    export: '导出',
    exportPDF: '导出PDF',
    confirm: '确定',
    save: '保存',
    cancel: '取消',
    add: '添加',
    confirmAndAdd: '保存后继续添加',
    readd: '重新添加',
    edit: '编辑',
    reedit: '重新编辑',
    delete: '删除',
    detail: '详情',
    detail_lower: '详情',
    submit: '提交',
    send: '发送',
    turnDown: '驳回',
    back: '返回',
  },
  week: {
    acedemicWeek: '学术周',
    addWeek: '添加学术周',
    schoolYear: '学年',
    semester: '学期',
    weekName: '学期周',
    startName: '开始时间',
    endDate: '结束时间',
    Operate: '操作',
    pleaseFill: '请输入',
    confirmDelete: '确认删除{content} !',
    edit: '编辑',
  },
  public: {
    colon: '：',
    switchLanguage: '您要切换语言吗？',
    page: '共有{total}条，每页显示{pageSize}条',
    searchList: '搜索{content}',
    operate: '操作',
    pleaseChoose: '请选择{content}',
    pleaseFill: '请填写{content}！',
    pleaseUpdate: '请上传{content}！',
    add: '添加{content}',
    edit: '编辑{content}',
    change: '更换{content}',
    delete: '删除{content}',
    title: '名称',
    title_lower: '名称',
    name: '名字',
    name_lower: '名字',
    englishName: '英文名',
    studentNumber: '学生数量',
    address: '地址',
    address_lower: '地址',
    saveSuccess: '保存成功！',
    confirmDelete: '确认删除？',
    deleteSuccess: '删除成功！',
    sendSuccess: '发送成功，待审核人审批！',
    turnDownSuccessfully: '驳回成功！',
    upload: '上传',
    uploadFailed: '上传失败！',
    uploadSuccess: '上传成功！',
    uploading: '正在上传文件！',
    status: '状态',
    status_lower: '状态',
    suspending: '休学',
    dropout: '退学',
    returnSchool: '返回学校',
    graduation: '毕业',
    enrollmentRecord: '学籍记录',
    close: '关闭',
    open: '开启',
    archive: '归档',
    active: '在读',
    remark: '备注',
    remark_lower: '备注',
    grade: '年级',
    grade_lower: '年级',
    student: '学生',
    student_lower: '学生',
    subject: '科目',
    teacher: '老师',
    classroom: '教室',
    class: '班级',
    class_lower: '班级',
    academicYear: '学年',
    semester: '学期',
    exam: '学期',
    account: '账户',
    account_lower: '账户',
    timeWeek: '时间/周',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',
    staff: '员工',
    staff_lower: '员工',
    all: '全部',
    grades: '学科成绩',
    grades_lower: '学科成绩',
    score: '成绩',
    score_lower: '成绩',
    comments: '评价',
    comments_lower: '评价',
    transcript: '学期成绩',
    officalTranscript: '全年成绩',
    averageScore: '平均成绩',
    level: '等级',
    editor: '编辑者',
    submitTime: '提交时间',
    content: '内容',
    schoolYears: '学年',
    headmaster: '班主任',
    startedYear: '开班时间',
    department: '部门',
    department_lower: '部门',
    timetable: '课程表',
    permission: '权限',
    permission_lower: '权限',
    updateRecord: '更新记录',
    emptyUrl: '文件路径不存在',
    successfullyExported: '导出成功！',
    dateOfBirth: '出生日期',
    lastName: '姓',
    lastName_lower: '姓',
    firstName: '名',
    firstName_lower: '名',
    gender: '性别',
    male: '男',
    female: '女',
    enrollmentGradeTitle: '入读年级',
    enrollmentGrade: '入读年级',
    enrollmentGrade_lower: '入读年级',
    currentGrade: '当前年级',
    currentGrade_lower: '当前年级',
    enrollmentTime: '入读时间',
    enrollmentTime_lower: '入读时间',
    studentId: '学号',
    checkPending: '待审核',
    confirmModification: '确认修改',
    roster: '花名册',
    selected: '已选择',
    unselected: '未选择',
    attachment: '附件',
    attachment_lower: '附件',
    entryIntoForceTime: '生效时间',
    graduated: '已毕业',
    suspension: '休学',
    pre10: 'Pre-10',
    10: '10',
    11: '11',
    12: '12',
    classAdvisorFeedback: '班主任反馈',
    classAdvisorFeedback_lower: '班主任反馈',
    category: '类目',
    number: '数量',
    number_lower: '数量',
    record: '记录',
    campus: '学习中心',
    campus_lower: '学习中心',
    operator: '操作人',
    midterm: '期中',
    final: '期末',
    cumulativ: '累计',
    semester1: '第一学期',
    semester2: '第二学期',
    resetPassword: '重置密码',
    email: '邮箱',
    verificationCode: '验证码',

    workingDay: '工作日',
    time: '时间',
    position: '职务',
    mobile: '手机',
    id: 'ID',
    attendanceGroup: '考勤组',
    earliest: '最早',
    latest: '最晚',
    times: '次数',
    beLate: '迟到',
    holidayEarly: '早退',
    complete: '完成',
    notClockIn: '缺卡',
    duration: '时长',
    duration_lower: '时长',
    usedDuration: '已用时长',
    remainingDuration: '剩余时长',
    hour: '小时',
    hour_lower: '小时',
    location: '地点',
    members: '打卡人员',
    distance: '距离',
    scheduling: '排班',
    clockIn: '上班',
    clockOut: '下班',
    type: '类型',
    dateOfSubmission: '提交日期',
    auditor: '审核人',
    currentSchool: '目前就读',
    scoreReports: '成绩管理',
    quitSchool: '休学',
    dropOut: '退学',
    ClassAdviser: '班主任',
    addSuccessTips: '添加成功',
    messageCenter: '消息中心',
    approval: '审批',
    recordr: '记录',
    approveAll: '全部批准',
    approve: '批准',
    reject: '拒绝',
    scoreType: '分数类型',
    details: '详情',
    oldScore: '旧分数',
    newScore: '分数',
    submissionTime: '提交时间',
    submitter: '提交人',
    approveTips: '是否确认',
    result: '结果',
    approver: '审批人',
    approvalTime: '审批时间',
    attendance: '出勤',
    assignment: '作业',
    participation: '参与度',
    quiz: '小测',
    week: '周',
    quizName: '小测名称',
    campusName: '校区名称',
    campusSelect: '选择校区',
    studentNumberO: '在读学生数量',
    chineseName: '中文名',
    fristName: '名的拼音',
    lastNameDetail: '姓的拼音',
    statisticsStudent: '数据概况（学生）',
    statisticsSubject: '数据概况（科目）',
    exportData: '确认导出当前数据？',
  },

  user: {
    account: '账户',
    password: '密码',
    passwordTip: '（初始密码：catschina0000）',
    signIn: '登录',
    signOut: '登出',
    signInSuccess: '登录成功！',
    changePassword: '修改密码',
    confirmPassword: '确认密码',
    newPasswordTip: '请填写新密码！',
    confirmPasswordTip: '请确认密码！',
    passwordsInconsistent: '您输入的两个密码不一致！',
    changePasswordSuccess: '修改密码成功！',
    reLogin: '登陆已过期，请重新登陆！',
    sendSuccess: '验证码已发送，请在邮箱查收！',
  },

  student: {
    manage: '学生管理',
    allStudent: '所有学生',
    newStudent: '新增学生',
    addStudent: '添加一个',
    majorType: '课程方向',
  },

  campus: {
    manage: '学习中心',
    allCampus: '所有学习中心',
    newCampus: '新增学习中心',
    addCampus: '添加一个',
    enterCampus: '进入学习中心',
  },

  staff: {
    permission: '权限',
    manage: '员工管理',
    allStaff: '所有员工',
    allDepartment: '所有部门',
    newStaff: '新增员工',
    addStaff: '添加一个',
    staffList: '员工列表',
    subject: '学科编辑',
    teachers: '任课老师',
    subjects: '学科',
    addSubject: '添加科目',
    delete: '删除',
    teacher: '任课老师',
    inputTipsSub: '请输入你的科目',
    applicableobject: '适应对象',
    allStudent: '全部学生',
    relatedStudent: '关联学生',
    promptSelection: '请选择{content}',
    addSubjects: '新增学科',
    type: '课程类型',
    campus: '校区',
    subjectName: '科目',
    science: '科学',
    english: '英语',
    liberalArts: '文科',
    arts: '艺术',
    music: '音乐',
    drama: '戏剧',
    PE: '体育',
    club: '俱乐部',
  },

  class: {
    manage: '班级管理',
    allClass: '所有班级',
    newClass: '新增班级',
    addClass: '添加一个',
    basic: '详情',
    promotion: '晋升',
    archive: '归档',
    errorTitle: '操作失败',
    messageDesc: '请选择班级',
    messageClass: '请选择学生',
    success: '成功',
    exportAll: '导出学生',
    sureExport: '确认导出当前学生？',
    sureExportTip: '会导出符合当前条件的所有学生。',
    classType: '班级类型',
    administrativeClass: '行政班',
    electiveClass: '学科班',
    addStudentErrorTips: '请选择需要添加的学生',
  },

  timetable: {
    manage: '课表管理',
    teacherTimetable: '老师课表',
    classTimetable: '班级课表',
    editTimetable: '编辑课表',
    deleteTimetable: '删除课表',
    occupied: '{className} 已占用',
    resetTimetable: '是否删除这些课程？',
    needSubject: '请选择科目！',
    needTeacher: '请选择老师！',
    import: '导入',
    downLoadTemplate: '下载模版',
  },
  statistics: {
    manage: '数据统计',
    overview: '数据概况',
    performace: '日常表现',
    weeks: '学期周',
    ExportStatistics: '导出',
    quiz: '小测',
    MidTermExam: '期中成绩',
    FinalTerm: '期末成绩',
    ComprehensiveResults: '综合成绩',
  },
  grades: {
    manage: '成绩管理',
    regularGrades: '平时表现',
    termGrades: '期中期末成绩',
    subjects: '学科',
    weeks: '教学周',
    weeks_lower: '周',
    advisorComment: '班主任评语',
    editWeek: '编辑教学周',
    participation: '参与度',
    participation_lower: '参与度',
    assignments: '作业',
    assignments_lower: '作业',
    attendance: '出勤',
    attendance_lower: '出勤',
    quiz: '测验',
    quiz_lower: '测验',
    basic: '平时成绩',
    midGradeTip:
      '各学科期中成绩并非学年最终成绩。各科目的学年成绩由课堂表现、家庭作业、出勤率、平时小测验、期中考试及期末考试成绩共同组成。  ',

    waitSave: '正在保存，请等待！',
    emptyGrade: '有未填写的成绩！',

    submitGradeTip:
      '请确认所有成绩信息填写正确。您只能提交一次。重新编辑需要验证。',
    reeditTip: '重新提交需要验证。会将验证请求发送到教务主管的账号进行确认。',
    verificationCode: '验证码',
    verificationCode_lower: '验证码',
    exportReport: '确认导出成绩单？',
    currentStudent: '当前学生',
    currentClass: '当前班级',
    confirmModificationResults: '确认修改成绩',
    currentGrade: '当前成绩',
    modifiedScore: '修改成绩',
    confirmModificationFeedback: '确认修改班主任反馈',
    currentFeedback: '当前反馈',
    modifiedFeedback: '修改反馈',
  },

  report: {
    manage: '成绩报告',
    submitGradeTip:
      '请确认所有成绩信息填写正确。您只能提交一次。重新编辑需要验证。',
    reeditTip: '重新提交需要验证。会将验证请求发送到教务主管的账号进行确认。',
    verificationCode: '验证码',
    verificationCode_lower: '验证码',
    exportReport: '确认导出成绩单？',
    currentStudent: '当前学生',
    currentClass: '当前班级',
    confirmModificationResults: '确认修改成绩',
    currentGrade: '当前成绩',
    modifiedScore: '修改成绩',
    confirmModificationFeedback: '确认修改班主任反馈',
    currentFeedback: '当前反馈',
    modifiedFeedback: '修改反馈',
    academicYear: '学年',
    grade: '年级',
    report: '报告',
    status: '状态',
    finalOperatingTime: '毕业年份',
    operate: '操作',
    reportCard: '学期成绩',
    officialTranscript: '全年成绩',
    reportCardTipsOpen: '开启学生成绩单',
    reportCardTipsClose: '关闭学生成绩单',
    reportCardName: '成绩管理',
    exportBasic: '确认导出平时成绩？',
  },

  scholarship: {
    manage: '学生行为',
    scholarship: '奖学金',
    reward: '奖励',
    punishment: '惩罚',
    punishment_lower: '惩罚',
    rewardPunishment: '奖励和惩罚',
    endStudy: '学习结束',
    monthStar: '每月之星',
    yellowCard: '黄牌',
    redCard: '红牌',
    recommendedReason: '推荐理由',
    medal: '奖章',
    referrer: '推荐人',
    homeroomTeacher: '班主任',
    learningDiscipline: '学习纪律',
    academicRecord: '学习成绩',
    recreationalActivities: '文体活动',
    competitionSelection: '比赛评选',
    award: '授予',
    scholarshipRecord: '奖励记录',
    punishmentRecord: '惩罚记录',
  },
}

export default zh_CN
